<template>
  <div class="Case">
    <div class="Case_box">
      <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>

      <div v-if="terminal == 'pc'" class="Case_box_bottom">
        <div class="Case_box_bottom_left" v-if="caseSdgList">
          <!-- ${item.color} -->
          <div
            class="Case_box_content"
            v-for="(item,index) in caseSdgList"
            :key="index"
            @click="toCurrentSdg(item,index)"
            :style="`--color:rgba(10,116,255,1)`"
            :class="[activeIndex == index? 'bgActive':'']"
          >
            <div class="name">
              <span
                class="title"
                :class="[activeIndex == index? 'active':'',language == 'zh'?'zhFamilytitle':'enfamilytitle']"
              >{{item.title}}</span>
            </div>
            <div
              class="info"
              :class="[activeIndex == index? 'activeInfo':'',language == 'zh'?'zhFamily':'enfamily']"
            >{{item.description}}</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="Case_box_bottom_right">
          <div class="Case_box_right" v-if="currentSdg" @click="toArticles(currentSdg.news.id)">
            <div class="Case_box_right_img_box">
              <img :src="`${GLOBAL.imageUrl}${currentSdg.news.icon}`" alt />
            </div>
            <p :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">{{currentSdg.news.title}}</p>
            <div
              :class="[language == 'zh'?'zhFamily':'enfamily']"
              v-html="
                  $options.filters.formatTime(currentSdg.news.content,language, 120, 220)
                "
            ></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="Case_box_bottom_mobile" v-if="caseSdgList">
          <div
            class="Case_box_content"
            v-for="(item,index) in caseSdgList"
            :key="index"
            @click="toCurrentSdg(item,index)"
            :style="`--color:${item.color}`"
            :class="[activeIndex == index? 'bgActive':'']"
          >
            <div class="name">
              <div class="title" :class="[activeIndex == index? 'active':'']">{{item.title}}</div>
              <div
                class="info"
                :class="[activeIndex == index? 'activeInfo':'']"
              >{{item.description}}</div>
            </div>
            <transition name="sub-menu">
              <div v-show="currentSdg.news.sdgId == item.id">
                <div
                  class="Case_box_right"
                  v-if="currentSdg"
                  @click="toArticles(currentSdg.news.id)"
                >
                  <div class="Case_box_right_img_box">
                    <img :src="`${GLOBAL.imageUrl}${currentSdg.news.icon}`" alt />
                  </div>
                  <p
                    :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
                  >{{currentSdg.news.title}}</p>
                  <div
                    :class="[language == 'zh'?'zhFamily':'enfamily']"
                    v-html="
                  $options.filters.formatTime(currentSdg.news.content, 120, 120)
                "
                  ></div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import { getCaseList } from "@/axios/api.js";
export default {
  mixins: [mapMixin],
  computed: {
    Module_title: function() {
      return {
        name: "Case",
        // color: "#fff",
        more: true,
        ehTitle: this.$t("Nav.Menu.Practices"),
        zhTitle: this.$t("Nav.Menu.Practices")
      };
    }
  },
  data() {
    return {
      // Module_title: { name: "Case", more: true  ,zhTitle:'Best Practices',enTitle:'Best Practices'},
      caseSdgList: [],
      currentSdg: null,
      activeIndex: 0,
      sdgId: ""
    };
  },
  filters: {
    formatTime: function(value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      msg = msg.replace(/\s+/g, " "); //去掉npsp
      // return msg.slice(0, zhNum).concat("......");
      if (language == "zh") {
        return msg.slice(0, zhNum).concat("......");
      } else {
        return msg.slice(0, enNum).concat("...");
      }
    }
  },
  mounted() {
    this.getCaseFun();
  },
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    },
    toCurrentSdg(sdgObject, index) {
      this.activeIndex = index;
      this.sdgId = sdgObject.id;
      this.getCaseFun();
    },
    async getCaseFun() {
      var channelName  = {
        'zh':'实践案例',
        'en':'Case',
        'fran':'Exemples pratiques'
      }
      
      var param = {

        channelName: channelName[ this.language],
        showRowCount: 5
      };
      if (this.sdgId) {
        param.sdgId = this.sdgId;
      }
      var res = await getCaseList(param);
      // 获取左侧Sdg菜单
      this.caseSdgList = res.data.data.targetList;
      // 当前目标的数据
      this.currentSdg = res.data.data.currentSdgMap;
    }
  },
  watch: {
    language() {
      this.getCaseFun();
    }
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue")
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1026px) {
  .zhFamilytitle {
    font-family: $zhFamily;
    font-size: 30px;
    line-height: 32px;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
    font-size: 30px;
    line-height: 32px;
  }
  .zhFamily {
    font-family: $zhFamily;
    font-size: 16px;
    line-height: 26px;
  }
  .enfamily {
    font-family: $enFamily;
    font-size: 16px;
  }
  .Case {
    margin: 40px 0 80px;
    // height: 600px;
    width: 100%;
    background: #fff;
    .Case_box {
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: column;
      .Case_box_bottom {
        // background: #ccc;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        //   align-items: flex-start;
        justify-content: space-between;
        .Case_box_bottom_left {
          // background: #f8f8f8;
          border-radius: 4px;
          height: 100%;
          width: 360px;
          // padding-left: 20px;
          .Case_box_content:first-child {
            // margin-top: 10px;
          }
          .bgActive {
            //  background: #4bbd58;
            // background: var(--color);
            opacity: 0.9;
            border-radius: 4px;
            // background: var(--color);
          }

          .Case_box_content {
            cursor: pointer;
            padding: 8px 10px 14px 10px;
            margin: 6px 0;
            //  padding:0 10px;
            // margin-bottom: 20px;
            // &:hover {
            //   border-radius: 4px;
            //   // background: var(--color);
            //   background: #4bbd58;
            // }

            &:hover .title {
              color: #51a4da !important;
              background-image: linear-gradient(#51a4da, #51a4da) !important;
              // color: #fff !important;
              opacity: 1 !important;
              transition-timing-function: cubic-bezier(
                0.23,
                1,
                0.32,
                1
              ) !important;
              background-size: 100% 2px !important;
            }
            &:hover .info {
              color: #51a4da;
              opacity: 1 !important;
            }

            .name {
              display: flex;
              flex-direction: row;
              align-items: center;
              position: relative;
              .active {
                opacity: 1 !important;
                transition-timing-function: cubic-bezier(
                  0.23,
                  1,
                  0.32,
                  1
                ) !important;
                background-size: 100% 2px !important;
                color: #51a4da !important;
              }
              .title {
                // opacity: 0.5;
                font-size: 16px;
                // height: 26px;
                line-height: 26px;
                font-weight: 600;
                // background-image: linear-gradient(var(--color), var(--color));
                background-image: linear-gradient(#fff, #fff);

                background-position: center bottom;
                background-repeat: no-repeat;
                transition: background-size 0.3s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;

                background-size: 0 2px;
                // color: var(--color);
              }
            }
            .activeInfo {
              // font-weight: 600;
              color: #51a4da !important;
              //  opacity: 1 !important;
            }
            .info {
              font-size: 14px;
              padding-top: 4px;
              // font-weight: 600;
              // color: var(--color);
              color: #666;
              // color: #333;
            }
          }
        }

        .Case_box_bottom_right {
          cursor: pointer;
          width: 780px;
          height: 100%;
          display: flex;
          flex-direction: column;
          &:hover img {
            transition: 0.8s ease;
            transform: scale(1.2, 1.2);
          }
          &:hover p {
            color: #51a4da !important;
          }

          .Case_box_right {
            width: 100%;
            height: 100%;
            .Case_box_right_img_box {
              margin-top: 20px;
              border-radius: 4px !important;
              width: 780px;
              height: 321px;
              overflow: hidden;
              img {
                transition: 0.8s ease;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            p {
              overflow: hidden; //溢出隐藏
              white-space: nowrap; //不换行
              text-overflow: ellipsis; //显示...
              margin-top: 24px;
              font-weight: 600;
              height: 25px;
              font-size: 18px;
              color: #000;
            }
            div {
              margin-top: 8px;
              background: #ffffff;
              font-size: 16px;
              color: #000 !important;
            }
          }
        }
        .line {
          margin-top: 20px;
          width: 1px;
          height: 388px;
          border: 1px solid #e7e7e7;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .Case {
    margin: 40px 0 80px;
    // height: 600px;
    width: 100%;
    background: #fff;
    .Case_box {
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: column;
      .Case_box_bottom {
        // background: #ccc;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        //   align-items: flex-start;
        justify-content: space-between;
        .Case_box_bottom_left {
          // background: #f8f8f8;
          border-radius: 4px;
          height: 100%;
          width: 360px;
          // padding-left: 20px;
          .Case_box_content:first-child {
            // margin-top: 10px;
          }
          .bgActive {
            //  background: #4bbd58;
            // background: var(--color);
            opacity: 0.9;
            border-radius: 4px;
            // background: var(--color);
          }

          .Case_box_content {
            cursor: pointer;
            padding: 8px 10px 14px 10px;
            margin: 6px 0;
            //  padding:0 10px;
            // margin-bottom: 20px;
            // &:hover {
            //   border-radius: 4px;
            //   // background: var(--color);
            //   background: #4bbd58;
            // }

            &:hover .title {
              color: #51a4da !important;
              background-image: linear-gradient(#51a4da, #51a4da) !important;
              // color: #fff !important;
              opacity: 1 !important;
              transition-timing-function: cubic-bezier(
                0.23,
                1,
                0.32,
                1
              ) !important;
              background-size: 100% 2px !important;
            }
            &:hover .info {
              color: #51a4da;
              opacity: 1 !important;
            }

            .name {
              display: flex;
              flex-direction: row;
              align-items: center;
              position: relative;
              .active {
                opacity: 1 !important;
                transition-timing-function: cubic-bezier(
                  0.23,
                  1,
                  0.32,
                  1
                ) !important;
                background-size: 100% 2px !important;
                color: #51a4da !important;
              }
              .title {
                // opacity: 0.5;
                font-size: 16px;
                // height: 26px;
                line-height: 26px;
                font-weight: 600;
                // background-image: linear-gradient(var(--color), var(--color));
                background-image: linear-gradient(#fff, #fff);

                background-position: center bottom;
                background-repeat: no-repeat;
                transition: background-size 0.3s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;

                background-size: 0 2px;
                // color: var(--color);
              }
            }
            .activeInfo {
              // font-weight: 600;
              color: #51a4da !important;
              //  opacity: 1 !important;
            }
            .info {
              font-size: 14px;
              padding-top: 4px;
              // font-weight: 600;
              // color: var(--color);
              color: #666;
              // color: #333;
            }
          }
        }

        .Case_box_bottom_right {
          cursor: pointer;
          width: 780px;
          height: 100%;
          display: flex;
          flex-direction: column;
          &:hover img {
            transition: 0.8s ease;
            transform: scale(1.2, 1.2);
          }
          &:hover p {
            color: #51a4da !important;
          }

          .Case_box_right {
            width: 100%;
            height: 100%;
            .Case_box_right_img_box {
              margin-top: 20px;
              border-radius: 4px !important;
              width: 780px;
              height: 321px;
              overflow: hidden;
              img {
                transition: 0.8s ease;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            p {
              overflow: hidden; //溢出隐藏
              white-space: nowrap; //不换行
              text-overflow: ellipsis; //显示...
              margin-top: 24px;
              font-weight: 600;
              height: 25px;
              font-size: 18px;
              color: #000;
            }
            div {
              margin-top: 8px;
              background: #ffffff;
              font-size: 16px;
              color: #000 !important;
            }
          }
        }
        .line {
          margin-top: 20px;
          width: 1px;
          height: 388px;
          border: 1px solid #e7e7e7;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .Case {
    margin: 0px 0 0px;
    // height: 600px;
    width: 100%;
    background: #fff;
    .Case_box {
      padding: 0 10px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: column;

      .Case_box_bottom_mobile {
        // padding: 10px;
        overflow: hidden;
        border-radius: 4px;
        height: 100%;
        margin-bottom: 40px;
        .Case_box_content {
          // background: var(--color);
          padding-bottom: 4px;
          border-radius: 10px;
          .name {
            // border-top-left-radius: 4px;
            // border-top-right-radius: 4px;
            border-radius: 4px;
            background: var(--color);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 10px;
            position: relative;
            .title {
              font-size: 18px;
              font-weight: 600;
              color: #fff;
              background-size: 0 2px;
            }
            .info {
              margin-top: 4px;
              font-size: 14px;
              // padding-top: 4px;
              // font-weight: 600;
              // color: var(--color);
              color: #fff;
              // color: #333;
            }
          }
          .activeInfo {
            // font-weight: 600;
            // color: #fff !important;
            //  opacity: 1 !important;
          }

          .Case_box_right {
            // width: 100%;
            // height: 100%;
            min-height: 462px;
            // margin-bottom: 20px;
            .Case_box_right_img_box {
              // margin-top: 10px;
              // border-radius: 4px !important;
              width: 100%;
              overflow: hidden;
              img {
                transition: 0.8s ease;
                width: 100%;
                height: 335px;
                object-fit: cover;
              }
            }

            p {
              background: transparent;
              margin-top: 10px;
              font-weight: 600;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
            }
            div {
              background: #ffffff;
              font-size: 14px;
              color: #000 !important;
              font-family: PingFangSC-Regular, PingFang SC;
            }
          }
        }
      }
    }
  }
}

.sub-menu-enter-active,
.sub-menu-leave-active {
  transition: all 0.3s ease;
  // height: 100vh;
  height: 462px; /* 这里70px为menu-one子菜单的高度 */
}
.sub-menu-enter,
.sub-menu-leave-to {
  opacity: 0;
  height: 0px;
}
</style>